module.exports = __webpack_public_path__ + "img/modalclose.265a29a6.svg";